import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=8fc563ea&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=8fc563ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc563ea",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileData: require('/home/bitrix/frontend/components/profile/ProfileData.vue').default,MtInput: require('/home/bitrix/frontend/components/form/MtInput.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default})
